export default __webpack_public_path__ + "static/media/polygon-logo.910e1faf.png";